import { jsx as l } from "react/jsx-runtime";
import c from "@mui/material/SvgIcon";
import * as t from "react";
import { forwardRef as f } from "react";
const m = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "12 8 10 16", ...e }, /* @__PURE__ */ t.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m11 15.977 8.15 7.725a1.11 1.11 0 0 0 1.496.015 1.01 1.01 0 0 0 .012-1.497l-6.376-6.243L20.67 9.84c.437-.42.439-1.1.005-1.521a1.15 1.15 0 0 0-1.58-.01l-4.048 3.834z", clipRule: "evenodd" })), a = /* @__PURE__ */ f(({ size: e = "inherit", sx: o, ...n }, r) => {
  const i = typeof o == "function" ? o : {
    fontSize: e,
    ...o
  };
  return /* @__PURE__ */ l(c, {
    ...n,
    ref: r,
    component: m,
    inheritViewBox: !0,
    sx: i
  });
});
a.displayName = "svg_chevron_left";
export {
  a as default
};
